import About from "./About";
import Contact from "./Contact";
import Home01 from "./Home01";
import Team from "./Team";
import VisionsMission from "./VisionsMission";
import Services from "./Services"; // ✅ Import added
import Pricing from "./Pricing"; // ✅ New Pricing page
import MarketInfo from './MarketInfo';
import ThingsWeTrade from './ThingsWeTrade';
import MarketSpread from './MarketSpread';
import Terms from './Terms';
import PrivacyPolicy from './PrivacyPolicy';
import Disclaimer from './Disclaimer';
import RefundPolicy from './RefundPolicy';

const routes = [
  { path: '/', component: <Home01 /> },
  
  { path: '/visions-mission', component: <VisionsMission /> },
  { path: '/about', component: <About /> },
  { path: '/team', component: <Team /> },
  { path: '/contact', component: <Contact /> },
{ path: '/pricing', component: <Pricing /> }, // ✅ Pricing route added
{ path: '/market-info', component: <MarketInfo /> },
  { path: '/things-we-trade', component: <ThingsWeTrade /> },
  { path: '/market-spread', component: <MarketSpread /> },
  { path: '/terms', component: <Terms /> },
  { path: '/privacy-policy', component: <PrivacyPolicy /> },
  { path: '/disclaimer', component: <Disclaimer /> },
  { path: '/refund-policy', component: <RefundPolicy /> },

  { path: '/services', component: <Services /> }, // ✅ Services route added
];

export default routes;
